const CONTACT_SUPPORT = {
    EMAIL: 'support@rensecurehealth.com',
    NUMBER: '(888) 612-1172',
    WEB_SITE: 'https://renaissancebenefits.com',
    BILLING_EMAIL: 'billing@joinansel.com'
};

const STRATEGIC_PARTNER = Object.freeze({
    LABEL: 'RenSecureHealth',
    PALETTE: {
        PRIMARY: '#0067A1',
        SECONDARY: '#223A67'
    },
    CONTACT_SUPPORT,
    S3: {
        BASE_URL: 'https://joinansel-platform-assets.s3.us-east-1.amazonaws.com',
        SP_NAME: 'renaissance',
        APPLICATION: 'member',
    },
    LEGAL:{
        INSURANCE_NAME: 'Renaissance Holding Company',
        SERVICE_NAME: 'Renaissance Life & Health Insurance Company of America',
        TERMS: `${CONTACT_SUPPORT.WEB_SITE}/terms-of-service/`,
        PRIVACY: `${CONTACT_SUPPORT.WEB_SITE}/privacy/`,
    }
});

export default STRATEGIC_PARTNER;
